export default "__VITE_ASSET__f1z0NK21__"